import { Box, Table, Tbody, Th, Tr } from '@chakra-ui/react';
import React from 'react';

import type { UserOpsItem } from 'types/api/userOps';

import config from 'configs/app';
import { useI18n } from 'lib/i18n/context';
import { default as Thead } from 'ui/shared/TheadSticky';
import { USER_OPS_FIELD_KEYS } from 'ui/userOps/i18n';

import UserOpsTableItem from './UserOpsTableItem';

 type Props = {
   items: Array<UserOpsItem>;
   isLoading?: boolean;
   top: number;
   showTx: boolean;
   showSender: boolean;
 };

const UserOpsTable = ({ items, isLoading, top, showTx, showSender }: Props) => {
  const { t } = useI18n();

  return (
    <Box overflowX="auto" overflowY="hidden">
      <Table minW="1000px">
        <Thead top={ top }>
          <Tr>
            <Th w="60%">{ t(USER_OPS_FIELD_KEYS.userOpHash) }</Th>
            <Th w="110px">{ t(USER_OPS_FIELD_KEYS.age) }</Th>
            <Th w="140px">{ t(USER_OPS_FIELD_KEYS.status) }</Th>
            { showSender && <Th w="160px">{ t(USER_OPS_FIELD_KEYS.sender) }</Th> }
            <Th w="220px">{ t('userOp.entryPoint') }</Th>
            { showTx && <Th w="160px">{ t(USER_OPS_FIELD_KEYS.txHash) }</Th> }
            <Th w="40%">{ t(USER_OPS_FIELD_KEYS.block) }</Th>
            { !config.UI.views.tx.hiddenFields?.tx_fee && (
              <Th w="120px" isNumeric>
                { t(USER_OPS_FIELD_KEYS.feeWithSymbol, { symbol: config.chain.currency.symbol }) }
              </Th>
            ) }
          </Tr>
        </Thead>
        <Tbody>
          { items.map((item, index) => {
            return (
              <UserOpsTableItem
                key={ item.hash + (isLoading ? String(index) : '') }
                item={ item }
                isLoading={ isLoading }
                showSender={ showSender }
                showTx={ showTx }
              />
            );
          }) }
        </Tbody>
      </Table>
    </Box>
  );
};

export default UserOpsTable;
